import { Navigate, useLocation, useOutlet } from "react-router-dom";

import { useAuth } from "../Hooks/useAuth";

import React from "react";
import { PopupNotificationProvider } from "Context/NotificationPopup";

export default function ProtectedMypagesLayout() {
  const { authData } = useAuth();
  const outlet = useOutlet();
  const location = useLocation();

  if (!authData || authData.userType !== "client") {
    // Redirect them to the `/` page (login), but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the default home page.
    return (
      <PopupNotificationProvider>
        <Navigate to="/login" state={{ from: location }} replace />
      </PopupNotificationProvider>
    );
  }

  return <PopupNotificationProvider>{outlet}</PopupNotificationProvider>;
}
